// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d32f1a28","952":"81a9f993","966":"bad1cc14"}[chunkId] + ".chunk.js";
};